// ====== plugin import ======= //
import React from 'react'
import { Link } from 'react-router-dom';
// ======== component import ======== //
import { 
    SectionHeader_1,
    Card_2
} from '../../../component/landingComponent'
const TruVoicePlatform = () => {
    return (
        <>
            <div className="container">
                <div className="features-area-inner">
                    <div className="section-header text-center">
                        <SectionHeader_1
                            title={`TruVoice Platform`}
                            subTitle={`The easiest way to create powerful AI Agents`}
                            text={`Use this simple intuitive UI to make full-featured AI Agents. This No-code platform allows you to create in-depth conversational experience in a few clicks. TruVoice platform comes with many in-built conversation handlers which maximizes your customer’s experience.`}
                        />
                    </div>
                    <div className="section-content">
                        <div className="features-wrapper">
                            <Link to="/truvoice-platform#how-its-works">
                                <Card_2
                                    icon={`/assets/img/tvicon/how-works.png`}
                                    title={`How it works?`}
                                    subTitle={`Discover how simple it is`}
                                />
                            </Link>
                            <Link to="/truvoice-platform#developer-guide">
                                <Card_2
                                    icon={`/assets/img/tvicon/user-guide.png`}
                                    title={`Developer Guide`}
                                    subTitle={`Step-by-step guide`}
                                />
                            </Link>
                            {/* truvoice-platform#pricing */}
                            <Link to="truvoice-platform#pricing"> 
                                <Card_2
                                    icon={`/assets/img/tvicon/pricing.png`}
                                    title={`Pricing`}
                                    subTitle={`Usage based pricing`}
                                />
                            </Link>
                            <Link to="/truvoice-platform#integration">
                                <Card_2
                                    icon={`/assets/img/tvicon/integration.png`}
                                    title={`Channels`}
                                    subTitle={`Integrate API for any application`}
                                />
                            </Link>
                        </div>
                        <div className="features-thumb">
                            <img className="radius-20" src="/assets/img/tv-platform.jpg" alt="image" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export {TruVoicePlatform}